export default __webpack_public_path__ + "static/banner-dc776325f820f1e745ced8b94af655d2.jpg";